import { SortingOption } from '~src/shared/sortSelector/SortSelector';
import { SortingValues } from '~src/modules/reports/shared/constants/filterAndSortingKeys';

export const surveysSortingOptions = (locale: string): SortingOption[] => [
  {
    name: SortingValues.Created_desc,
    translationKey: 'x.surveys.list.filter.latest_created',
  },
  {
    name: SortingValues.Created_asc,
    translationKey: 'x.surveys.list.filter.oldest_created',
  },
  {
    name: SortingValues.ResponseRate_desc,
    translationKey: 'x.surveys.list.filter.highest_response_rate',
  },
  {
    name: SortingValues.ResponseRate_asc,
    translationKey: 'x.surveys.list.filter.lowest_response_rate',
  },
  {
    name: SortingValues.RecentlyAnswered_desc,
    translationKey: 'x.surveys.list.filter.most_recently_answered',
  },
  {
    name: SortingValues.RecentlyAnswered_asc,
    translationKey: 'x.surveys.list.filter.least_recently_answered',
  },
  {
    name: SortingValues.MostAnswered_desc,
    translationKey: 'x.surveys.list.filter.most_answered',
  },
  {
    name: SortingValues.MostAnswered_asc,
    translationKey: 'x.surveys.list.filter.least_answered',
  },
  {
    name: `${SortingValues.SurveyNames_asc}.${locale}`,
    translationKey: 'x.surveys.list.filter.a_to_z',
  },
  {
    name: `${SortingValues.SurveyNames_desc}.${locale}`,
    translationKey: 'x.surveys.list.filter.z_to_a',
  },
];
